import { useEffect, useState } from "react";

const links = [
  { label: "Services", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const textColor = scrolled ? "text-foreground-900" : "text-white";
  const linkColor = scrolled
    ? "text-foreground-600 hover:text-primary-600"
    : "text-white/75 hover:text-white";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between h-16 md:h-20 px-4 md:px-6 max-w-7xl mx-auto">
        {/* Logo */}
        <a href="#top" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="w-9 h-9 rounded-md bg-gradient-to-br from-primary-500 to-accent-400 flex items-center justify-center">
            <i className="ri-shield-check-line text-white text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className={`font-heading font-bold text-[13px] tracking-wide ${textColor}`}>
              THE TECH CONSULTANTS
            </span>
            <span
              className={`text-[10px] tracking-[0.3em] font-semibold ${
                scrolled ? "text-primary-600" : "text-accent-300"
              }`}
            >
              LLC
            </span>
          </span>
        </a>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 ${linkColor}`}
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#contact"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 text-white px-5 py-2.5 text-sm font-semibold hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            Get a Free Consultation
          </a>
        </div>

        {/* Mobile hamburger */}
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${
            scrolled ? "text-foreground-800" : "text-white"
          }`}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t border-background-200 px-4 py-4">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 rounded-md text-foreground-700 hover:bg-background-100 text-sm font-medium cursor-pointer"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 text-white px-5 py-3 text-sm font-semibold cursor-pointer"
            >
              Get a Free Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}